/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Clear_Descriptions_ConfirmInputs */

const en_markers_clear_descriptions_confirm = /** @type {(inputs: Markers_Clear_Descriptions_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure you want to clear all marker descriptions?`)
};

const fr_markers_clear_descriptions_confirm = /** @type {(inputs: Markers_Clear_Descriptions_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voulez-vous vraiment effacer toutes les descriptions de marqueurs ?`)
};

const de_markers_clear_descriptions_confirm = /** @type {(inputs: Markers_Clear_Descriptions_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Möchten Sie wirklich alle Markierungsbeschreibungen löschen?`)
};

const it_markers_clear_descriptions_confirm = /** @type {(inputs: Markers_Clear_Descriptions_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vuoi davvero cancellare tutte le descrizioni dei marcatori?`)
};

const ru_markers_clear_descriptions_confirm = /** @type {(inputs: Markers_Clear_Descriptions_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы уверены, что хотите удалить все описания маркеров?`)
};

const es_markers_clear_descriptions_confirm = /** @type {(inputs: Markers_Clear_Descriptions_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Está seguro de que desea borrar todas las descripciones de marcadores?`)
};

const zh_cn2_markers_clear_descriptions_confirm = /** @type {(inputs: Markers_Clear_Descriptions_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您确定要清除所有标记描述吗？`)
};

const ja_markers_clear_descriptions_confirm = /** @type {(inputs: Markers_Clear_Descriptions_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてのマーカーの説明をクリアしてもよろしいですか?`)
};

const hi_markers_clear_descriptions_confirm = /** @type {(inputs: Markers_Clear_Descriptions_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्या आप वाकई सभी मार्कर विवरणों को हटाना चाहते हैं?`)
};

const pt_pt2_markers_clear_descriptions_confirm = /** @type {(inputs: Markers_Clear_Descriptions_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tem certeza de que deseja apagar todas as descrições dos marcadores?`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to clear all marker descriptions?" |
*
* @param {Markers_Clear_Descriptions_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_clear_descriptions_confirm = /** @type {((inputs?: Markers_Clear_Descriptions_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Clear_Descriptions_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_markers_clear_descriptions_confirm(inputs)
	if (locale === "de") return de_markers_clear_descriptions_confirm(inputs)
	if (locale === "it") return it_markers_clear_descriptions_confirm(inputs)
	if (locale === "ru") return ru_markers_clear_descriptions_confirm(inputs)
	if (locale === "es") return es_markers_clear_descriptions_confirm(inputs)
	if (locale === "zh-CN") return zh_cn2_markers_clear_descriptions_confirm(inputs)
	if (locale === "ja") return ja_markers_clear_descriptions_confirm(inputs)
	if (locale === "hi") return hi_markers_clear_descriptions_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_markers_clear_descriptions_confirm(inputs)
	return en_markers_clear_descriptions_confirm(inputs)
});